import type { AffiliateStockListing, CapiProductPage } from 'types/capi/pdp';
import { fromProductDetailPage } from 'types/TrackableProduct';

import RetailerInteractionEvent, {
  type RetailerPlacement
} from '~/events/RetailerInteractionEvent';
import usePageData from '~/hooks/usePageData';
import useRootData from '~/hooks/useRootData';
import useUser from '~/hooks/useUser';
import {
  getSortedStockListingsForSize,
  toRetailerOption
} from '~/utils/listings';

type FireOptions = {
  listing: AffiliateStockListing;
  placement: RetailerPlacement;
  selectedSize?: string;
};

export default function useRetailerInteraction() {
  const { isBot } = useRootData();
  const user = useUser();
  const page = usePageData<CapiProductPage>();

  return ({ listing, placement, selectedSize }: FireOptions) => {
    const retailers = getSortedStockListingsForSize(page, selectedSize).map(
      (option, index) => toRetailerOption(option, index, selectedSize)
    );

    return new RetailerInteractionEvent({
      guestId: user.guestId,
      isBot,
      placement,
      product: fromProductDetailPage(page),
      retailerId: listing.affiliate.canonical_id,
      retailers,
      selectedSize
    }).send();
  };
}
